import { Outlet, useLocation } from "react-router-dom"
import Study from "@/modules/study/components/study"
import { PRODUCT_TOUR_STEPS } from "@/modules/product-tour/constants/steps"

export default function StudyPage() {
  const location = useLocation()
  const isRootStudy = location.pathname === "/study"

  return (
    <div id={PRODUCT_TOUR_STEPS.STUDY_START} className="flex w-full">
      {isRootStudy && <Study />}
      <Outlet />
    </div>
  )
}
